import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import HeroSection from "../components/HeroSection";
import AboutSection from "../components/AboutSection";
import DivisionsSection from "../components/DivisionsSection";
import GhostAssistantSection from "../components/GhostAssistantSection";
import CharityPartnersSection from "../components/CharityPartnersSection";
import ImpactSection from "../components/ImpactSection";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";
import GhostAssistantButton from "../components/GhostAssistantButton";

const HomePage = () => {
  const [isVisible, setIsVisible] = useState({});

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible((prev) => ({ ...prev, [entry.target.id]: true }));
          }
        });
      },
      { threshold: 0.1 }
    );

    const sections = document.querySelectorAll(".section-fade");
    sections.forEach((section) => observer.observe(section));

    return () => observer.disconnect();
  }, []);

  return (
    <div className="min-h-screen bg-white" data-testid="homepage">
      <Header />
      <main>
        <HeroSection />
        <AboutSection isVisible={isVisible.about} />
        <DivisionsSection isVisible={isVisible.divisions} />
        <GhostAssistantSection isVisible={isVisible.ghost} />
        <CharityPartnersSection isVisible={isVisible.charities} />
        <ImpactSection isVisible={isVisible.impact} />
        <ContactSection isVisible={isVisible.contact} />
      </main>
      <Footer />
      <GhostAssistantButton />
    </div>
  );
};

export default HomePage;
